var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "spinner_svg__svg-public/img/icons/spinner_svga",
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "spinner_svg__svg-public/img/icons/spinner_svgb"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#020202",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-146 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#040404",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-144 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#060606",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-142 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#080808",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-140 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#0A0A0A",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-138 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#0C0C0C",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-136 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#0E0E0E",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-134 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#101010",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-132 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#131313",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-130 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#151515",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-128 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#171717",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-126 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#191919",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-124 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#1B1B1B",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-122 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#1D1D1D",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-120 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#1F1F1F",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-118 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#212121",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-116 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#242424",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-114 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#262626",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-112 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#282828",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-110 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#2A2A2A",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-108 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#2C2C2C",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-106 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#2E2E2E",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-104 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#303030",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-102 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#323232",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-100 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#353535",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-98 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#373737",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-96 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#393939",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-94 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#3B3B3B",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-92 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#3D3D3D",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-90 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#3F3F3F",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-88 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#414141",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-86 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#434343",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-84 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#464646",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-82 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#484848",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-80 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#4A4A4A",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-78 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#4C4C4C",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-76 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#4E4E4E",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-74 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#505050",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-72 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#525252",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-70 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#545454",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-68 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#575757",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-66 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#595959",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-64 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5B5B5B",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-62 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5D5D5D",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-60 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5F5F5F",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-58 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#616161",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-56 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#636363",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-54 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#656565",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-52 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#686868",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-50 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#6A6A6A",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-48 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#6C6C6C",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-46 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#6E6E6E",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-44 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#707070",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-42 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#727272",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-40 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#747474",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-38 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#767676",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-36 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#797979",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-34 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#7B7B7B",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-32 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#7D7D7D",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-30 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#7F7F7F",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-28 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#818181",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-26 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#838383",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-24 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#858585",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-22 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#878787",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-20 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#8A8A8A",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-18 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#8C8C8C",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-16 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#8E8E8E",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-14 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#909090",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-12 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#929292",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-10 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#949494",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-8 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#969696",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-6 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#989898",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-4 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#9B9B9B",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(-2 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#9D9D9D",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#9F9F9F",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(2 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#A1A1A1",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(4 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#A3A3A3",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(6 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#A5A5A5",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(8 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#A7A7A7",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(10 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#A9A9A9",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(12 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#ACACAC",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(14 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#AEAEAE",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(16 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#B0B0B0",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(18 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#B2B2B2",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(20 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#B4B4B4",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(22 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#B6B6B6",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(24 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#B8B8B8",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(26 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#BABABA",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(28 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#BDBDBD",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(30 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#BFBFBF",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(32 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#C1C1C1",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(34 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#C3C3C3",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(36 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#C5C5C5",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(38 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#C7C7C7",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(40 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#C9C9C9",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(42 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#CBCBCB",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(44 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#CECECE",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(46 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D0D0D0",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(48 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D2D2D2",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(50 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D4D4D4",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(52 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D6D6D6",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(54 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(56 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#DADADA",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(58 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#DCDCDC",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(60 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#DFDFDF",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(62 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#E1E1E1",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(64 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#E3E3E3",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(66 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#E5E5E5",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(68 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#E7E7E7",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(70 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#E9E9E9",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(72 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#EBEBEB",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(74 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#EDEDED",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(76 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F0F0F0",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(78 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F2F2F2",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(80 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F4F4F4",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(82 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F6F6F6",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(84 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F8F8F8",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(86 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FAFAFA",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(88 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FCFCFC",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(90 32 32)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FEFEFE",
    xlinkHref: "#spinner_svg__svg-public/img/icons/spinner_svga",
    transform: "rotate(92 32 32)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.6 47.6c-1.98-1.98-5.09-1.98-7.07 0-8.56 8.56-22.6 8.56-31.1 0-8.56-8.56-8.56-22.6 0-31.1 4.54-5.58-3.25-10.7-7.07-7.07-12.4 12.4-12.4 32.8 0 45.3 12.4 12.4 32.8 12.4 45.3 0 1.98-1.98 1.98-5.09 0-7.07zM32 54c-12.1 0-22-9.9-22-22s9.9-22 22-22c2.8 0 5-2.2 5-5s-2.2-5-5-5C14.4 0 0 14.4 0 32s14.4 32 32 32c7.16-.736 5.26-9.84 0-10z",
    mask: "url(#spinner_svg__svg-public/img/icons/spinner_svgb)"
  })));
}

export default "data:image/svg+xml;base64,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";
export { SvgSpinner as ReactComponent };